module.exports = __webpack_public_path__ + "assets/img/baoguan.7ff57771.png";